import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/bookings/{id}']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getBookingById = async ({ id }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/bookings/${id}`, { params: { id } });
  return response.data;
};

export default getBookingById;
